import { Autorenew, CheckCircle, Visibility } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { format, parseISO } from "date-fns";
import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import { Table } from "../../components/Table";
import { Import as TypeImport } from "../../types/imports";
import { listImports } from "../../services/imports";
import { DetailsImport } from "./Details";
import { useStyles } from "./styles";
import { MenuButton } from "../../components/MenuButton";
import MenuItem from "@mui/material/MenuItem";
import { NewImport } from "./New";
import { queryClient } from "../../services/queryClient";

type Identificator = "documento" | "cupom";

export function Import() {
  const styles = useStyles();

  const [identificator, setIdentificator] =
    useState<Identificator>("documento");
  const [fileImport, setFileImport] = useState<TypeImport | null>(null);
  const [dialogDetailsImport, setDialogDetailsImport] =
    useState<boolean>(false);
  const [dialogNewImport, setDialogNewImport] = useState<boolean>(false);

  const imports = useQuery("imports", listImports);

  const handleDialogDetailsImport = useCallback((row: TypeImport | null) => {
    setFileImport(row);
    setDialogDetailsImport((prev) => !prev);
  }, []);

  const handleDialogNewImport = useCallback((type: Identificator) => {
    setIdentificator(type);
    setDialogNewImport((prev) => !prev);
  }, []);

  const invalidateImports = useCallback(() => {
    queryClient.invalidateQueries("imports");
  }, []);

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Importação</Typography>
      </div>
      <div className={styles.rootActions}>
        <MenuButton label="Importar" variant="contained">
          <MenuItem
            onClick={() => {
              handleDialogNewImport("documento");
            }}
          >
            Cadastros
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleDialogNewImport("cupom");
            }}
          >
            Vendas
          </MenuItem>
        </MenuButton>

        <Tooltip title="Atualizar lista" placement="top">
          <IconButton onClick={invalidateImports} className={styles.btnPutList}>
            <Autorenew />
          </IconButton>
        </Tooltip>
      </div>
      <Paper variant="outlined" elevation={0} className={styles.paper}>
        <Table
          toolbar={false}
          data={imports.data as []}
          isLoading={imports.isFetching}
          columns={[
            { title: "Nome", field: "file_name" },
            {
              title: "Data de importação",
              field: "data_insert",
              render: (row) =>
                format(
                  parseISO(row.data_insert?.replace("Z", "")),
                  "dd/MM/yyyy HH:mm"
                ),
            },
            {
              title: "Status da importação",
              align: "center",
              field: "queue_processed",
              render: (row) =>
                Boolean(Number(row.queue_processed)) ? (
                  <Tooltip title="Importação concluída" placement="top">
                    <CheckCircle style={{ fontSize: 25, color: green[600] }} />
                  </Tooltip>
                ) : (
                  <Tooltip title="Importação em andamento" placement="top">
                    <CircularProgress size={22} thickness={4} />
                  </Tooltip>
                ),
            },
            {
              title: "Ações",
              align: "center",
              render: (row) => (
                <Tooltip title="Ver detalhes" placement="top">
                  <IconButton
                    onClick={() => {
                      handleDialogDetailsImport(row);
                    }}
                  >
                    <Visibility />
                  </IconButton>
                </Tooltip>
              ),
            },
          ]}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
        />
      </Paper>
      <DetailsImport
        data={fileImport}
        open={dialogDetailsImport}
        onClose={() => {
          handleDialogDetailsImport(null);
        }}
      />
      <NewImport
        identificator={identificator}
        open={dialogNewImport}
        onClose={() => {
          handleDialogNewImport("documento");
        }}
      />
    </>
  );
}
